import { useEffect } from "react";
import useEmblaCarousel from "embla-carousel-react";
import AutoScroll from "embla-carousel-auto-scroll";
import "./carousel.css";

// Easy to add new logos - just add the filename and the name the logo shows
const logos = [
  ["spc.jpg", "Sony Pictures Classics"],
  ["black-bear-logo.jpg", "Black Bear"],
  ["cineverse.png", "Cineverse"],
  ["amc-logo.jpg", "AMC"],
  ["warnerbros-logo.jpg", "Warner Bros."],
  ["universal-logo.jpg", "Universal"],
  ["imax-logo.jpg", "IMAX"],
  ["sony-logo.jpg", "Sony Pictures"],
  ["cinemark-logo.jpg", "Cinemark"],
  ["lionsgate-logo.jpg", "Lionsgate"],
  ["disney-logo.jpg", "The Walt Disney Studios"],
  ["cinemacon-logo.jpg", "CinemaCon"],
  ["barco-logo.jpg", "Barco"],
  ["kingdom-logo.jpg", "Kingdom Story Company"],
  ["fathom-logo.jpg", "Fathom Entertainment"],
  ["regal-logo.jpg", "Regal"],
  ["focus-logo.jpg", "Focus Features"],
  ["harkins-logo.jpg", "Harkins Theatres"],
  ["a24-logo.jpg", "A24"],
  ["marcus-logo.jpg", "Marcus Theatres"],
  ["coke-logo.jpg", "Coca-Cola"],
  ["showcase-logo.jpg", "Showcase Cinemas"],
  ["roadside-logo.jpg", "Roadside Attractions"],
  ["neon-logo.jpg", "Neon"],
  ["paramount-logo.jpg", "Paramount"],
  ["reald-logo.jpg", "RealD"],
  ["briarcliff-logo.jpg", "Briarcliff Entertainment"],
  ["trafalgar-logo.jpg", "Trafalgar Releasing"],
  ["vertical-logo.jpg", "Vertical Entertainment"],
  ["bb-logo.jpg", "B&B Theatres"],
  ["gkids-logo.jpg", "GKIDS"],
  ["bleecker-logo.jpg", "Bleecker Street"],
  ["mgm-logo.jpg", "Amazon MGM Studios"],
  ["cinemaunited-logo.jpg", "Cinema United"],
  ["cj4dplex-logo.jpg", "CJ 4DPlex"],
  ["dolby-logo.jpg", "Dolby"],
  ["mubi-logo.jpg", "MUBI"],
  ["screenx-logo.jpg", "ScreenX"],
  ["4g-logo.jpg", "4DX"],
];

// Visitors who turn on "reduce motion" get a still strip they can drag.
const reduceMotion =
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const Carousel = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
      dragFree: true,
      align: "start",
    },
    [
      AutoScroll({
        playOnInit: !reduceMotion,
        speed: 1,
        stopOnInteraction: false,
        stopOnMouseEnter: true,
      }),
    ]
  );

  // Enable horizontal wheel/trackpad scrolling
  useEffect(() => {
    if (!emblaApi) return;
    
    const viewport = emblaApi.rootNode();
    let wheelDelta = 0;
    
    const handleWheel = (e) => {
      // Only respond to horizontal scroll
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();
        
        // Create dampening effect for smoother experience
        wheelDelta += e.deltaX;
        
        // Much higher threshold for less sensitivity
        const threshold = 100;
        
        if (Math.abs(wheelDelta) >= threshold) {
          if (wheelDelta > 0) {
            emblaApi.scrollNext();
          } else {
            emblaApi.scrollPrev();
          }
          wheelDelta = 0; // Reset accumulator
        }
      }
    };
    
    viewport.addEventListener("wheel", handleWheel, { passive: false });
    
    return () => {
      viewport.removeEventListener("wheel", handleWheel);
    };
  }, [emblaApi]);

  return (
    <div className="embla-logos">
      <div className="embla-logos__viewport" ref={emblaRef}>
        <div className="embla-logos__container">
          {logos.map(([file, name], index) => (
            <div className="embla-logos__slide" key={index}>
              <img src={`./images/carousel/${file}`} height="100" alt={name} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Carousel;
